// Builds the text a regenerate-with-feedback request injects at `{{feedback}}`
// (D-10). Newest first, capped so a chatty review history can never blow past
// a template's context budget the way an uncapped join could.

import type { Output } from "./types.js";

const MAX_DOWN_COMMENTS = 3;
const MAX_CHARS = 2000;

function byNewestFirst(a: Output, b: Output): number {
  if (a.createdAt === b.createdAt) return 0;
  return a.createdAt < b.createdAt ? 1 : -1;
}

export function buildFeedback(outputs: Output[]): string {
  const newestFirst = [...outputs].sort(byNewestFirst);

  const downComments = newestFirst
    .filter((o) => o.rating === "down" && o.ratingComment)
    .slice(0, MAX_DOWN_COMMENTS)
    .map((o) => o.ratingComment as string);

  const notChosenReasons = newestFirst
    .filter((o) => o.chosen === false && o.chosenReason)
    .map((o) => o.chosenReason as string);

  const joined = [...downComments, ...notChosenReasons].join("\n");
  return joined.length > MAX_CHARS ? joined.slice(0, MAX_CHARS) : joined;
}
